import { ExamplesPayload } from '~/common/types/types';
import { TechnologyName } from '~/common/enums/enums';
import lime from '~/assets/img/project-examples/lime.gif';
import guruHub from '~/assets/img/project-examples/guru-hub.gif';
import calmPal from '~/assets/img/project-examples/calm-pal.gif';

const examplesPayload: ExamplesPayload = {
  title: 'technology.js.examples.title',
  techListTitle: 'technology.js.examples.techListTitle',
  items: [
    {
      title: 'technology.js.examples.group0.title',
      description: 'technology.js.examples.group0.description',
      imgPath: lime,
      imgBackgroundColor: '#1C2227',
      technologies: [
        TechnologyName.TYPESCRIPT,
        TechnologyName.REACT,
        TechnologyName.REDUX,
        TechnologyName.NODEJS,
        TechnologyName.FASTIFY,
        TechnologyName.POSTGRESQL,
        TechnologyName.SOCKET_IO,
        TechnologyName.OPEN_AI,
      ],
    },
    {
      title: 'technology.js.examples.group1.title',
      description: 'technology.js.examples.group1.description',
      imgPath: calmPal,
      imgBackgroundColor: '#527DED',
      technologies: [
        TechnologyName.TYPESCRIPT,
        TechnologyName.REACT,
        TechnologyName.REDUX,
        TechnologyName.NODEJS,
        TechnologyName.FASTIFY,
        TechnologyName.POSTGRESQL,
        TechnologyName.OPEN_AI,
        TechnologyName.STRIPE,
      ],
    },
    {
      title: 'technology.js.examples.group2.title',
      description: 'technology.js.examples.group2.description',
      imgPath: guruHub,
      imgBackgroundColor: '#1A1D3A',
      technologies: [
        TechnologyName.TYPESCRIPT,
        TechnologyName.REACT,
        TechnologyName.REDUX,
        TechnologyName.NODEJS,
        TechnologyName.FASTIFY,
        TechnologyName.POSTGRESQL,
        TechnologyName.SOCKET_IO,
        TechnologyName.STRIPE,
      ],
    },
  ],
};

export { examplesPayload };
